import {
  CustomCollection,
  Stream,
  StreamDeck,
} from '@/__generated__/schema-types.ts';
import { sourceConfigsToTargetsMap } from '@/components/stream-deck/list-form/custom-targets-section/source-custom-targets.ts';
import { ListForm } from '@/components/stream-deck/list-form/list-form.tsx';
import { sourceConfigsToSourceIdsMap } from '@/components/stream-deck/list-form/stream-sources-section/stream-source-ids.ts';
import { ManageListModal } from '@/components/stream-deck/manage-list-modal.tsx';
import { useAddCustomCollection } from '@/routes/_app.p.news-deck/use-add-custom-collection.ts';
import { useEditCustomCollection } from '@/routes/_app.p.news-deck/use-edit-custom-collection.ts';

export type StreamDeckColumnSelection = {
  streamDeck: StreamDeck;
  column: CustomCollection | 'new';
};

export const StreamDeckColumnModal = ({
  stream,
  selection: { streamDeck, column },
  onClose,
}: {
  stream: Stream;
  selection: StreamDeckColumnSelection;
  onClose: () => void;
}) => {
  const { addCollection, loading } = useAddCustomCollection(true);
  const { editCustomCollection, loading: editLoading } =
    useEditCustomCollection(true);

  const existing = column === 'new' ? null : column;
  const sources = !existing
    ? [stream]
    : existing.sources.some((source) => source.id === stream.id)
      ? existing.sources
      : [...existing.sources, stream];

  return (
    <ManageListModal
      title={existing ? 'Edit list' : 'Add list'}
      isOpen
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <ListForm
        isSubmitLoading={loading || editLoading}
        collectionId={existing?.id}
        submitText={existing ? 'Update' : 'Create'}
        initialValues={{
          name: existing?.name ?? '',
          sources,
          sourceCustomTargets: existing
            ? sourceConfigsToTargetsMap(existing.sourceConfigs)
            : undefined,
          streamSourceIds: existing
            ? sourceConfigsToSourceIdsMap(existing.sourceConfigs)
            : undefined,
          highlights: existing?.highlights,
          filters: existing?.filters ?? {},
          matchingSourcesOnly: existing?.matchingSourcesOnly,
        }}
        submit={async (val) => {
          if (existing) {
            await editCustomCollection({
              ...val,
              id: existing.id,
              streamDeckId: streamDeck.id,
            });
          } else {
            await addCollection({ ...val, streamDeckId: streamDeck.id });
          }
          onClose();
        }}
      />
    </ManageListModal>
  );
};
